// client/use-data-loading.ts
import { Change } from "@adornis/base/change.js";
import "@adornis/baseql/entities/adornisEntity.js";
import { constructValue } from "@adornis/baseql/entities/construct.js";
import { changeStream } from "@adornis/filter/change-stream.js";
import { useEffect, useObservable } from "@adornis/functional-lit/stateful.js";
import { usePagination } from "@adornis/pagination/use-pagination.js";
import { debounceTime, distinctUntilChanged, filter, map, tap } from "rxjs";
import "./data-view-options.js";
function useDataloading(options) {
  const opFilter = useObservable(
    () => options.view.whenChanging.pipe(
      map((view) => view.filter?.toObject()),
      filter(Boolean),
      distinctUntilChanged((a, b) => !Change.getDiff(a, b)?.length),
      map((filter2) => constructValue(filter2))
    ),
    [options]
  );
  const operation = options.operation;
  const selectionSet = useObservable(
    () => options.view.whenChanging.pipe(
      map((view) => view.toObject()),
      distinctUntilChanged(
        (a, b) => !Change.getDiff(a, b)?.find((diff) => diff.getPath().includes("configuredColumns"))
      ),
      map(() => options)
    ).pipe(
      map((options2) => options2.finalSelectionSet()),
      distinctUntilChanged(
        (a, b) => !Change.getDiff(a, b)?.filter((ch) => !["_id", "_class"].includes(ch.getPath().slice(-1)[0]))?.length
      )
    ),
    [options]
  );
  if (!opFilter || !selectionSet)
    return {
      data: [],
      loadingInitially: false,
      complete: true,
      totalRequested: 0,
      next: () => {
      },
      updateParameters: () => {
      }
    };
  useEffect(() => {
    const subscription = changeStream(options.view.whenChanging.pipe(map((view) => view.toObject()))).pipe(
      filter(Boolean),
      filter((ch) => !!ch.length),
      filter((ch) => ch.some((ch2) => !!ch2.getPath().length)),
      filter((ch) => ch.some((ch2) => !ch2.concernsPath(["selectedItems"]))),
      tap(
        (x) => console.log(
          "bubbling changes to persistence",
          x.map((c) => `${c.getPath().join(".")} - ${c.getValue()}`)
        )
      ),
      map(() => options),
      debounceTime(100)
    ).subscribe((options2) => options2.onViewChanged(options2.view));
    return () => subscription.unsubscribe();
  });
  if (!opFilter.sortingFields.includes("_id")) {
    opFilter.sortingFields.push("_id");
    opFilter.sortingDirections.push("asc");
  }
  return usePagination({ queryOrSubscription: operation, args: [opFilter], selectionSet });
}
export {
  useDataloading
};
